import type React from 'react';

import { Translate, useI18n } from '@change-corgi/core/react/i18n';
import { Button } from '@change-corgi/design-system-legacy/components/actions';
import { iconTiktok } from '@change-corgi/design-system-legacy/icons';
import { Box } from '@change-corgi/design-system-legacy/layout';

type Props = {
	onContinue: () => Promise<void>;
};

export const EducationModal: React.FC<Props> = ({ onContinue }) => {
	const { translate } = useI18n();

	return (
		<Box aria-label={translate('fe.components.psf.tiktok.modal_name')} mt={16}>
			<Button
				variant="primary"
				icon={iconTiktok}
				onClick={async () => onContinue()}
				sx={{ width: '100%' }}
				data-testid="tiktok-share-continue"
				data-qa="tiktok-share-continue"
			>
				<Translate value="fe.components.psf.tiktok.continue" />
			</Button>
		</Box>
	);
};
